import(/* webpackMode: "eager" */ "/vercel/path0/src/app/alerts/page.tsx");
